import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Menu } from 'antd';

import { IChannelsList } from 'types/components/menu';
import { IAccountState, IRootReducer } from 'types/reducers';
import { isSelected } from 'services/utils/helper';
import { useLocalization } from 'hooks';
import { DxIcon } from 'components';

interface ILeftNavMenuProps {
    list: IChannelsList[];
    selectedKeys: string[];
}

const LeftNavChannels: FC<ILeftNavMenuProps> = ({ selectedKeys, list }) => {
    const { t } = useLocalization();
    const { channels, permissions } = useSelector<IRootReducer, IAccountState>((state) => state.account);

    return (
        <>
            <Menu className={`dx-menu`} mode="inline" selectedKeys={selectedKeys}>
                {list.map(
                    ({ channel, label, link, icon, viewRule }) =>
                        isSelected(channel, channels) && (
                            <Menu.Item
                                className={`dx-menu-item ${permissions[viewRule]!.canView ? '' : 'custom-disable'}`}
                                key={link}
                            >
                                {permissions[viewRule]!.canView ? (
                                    <Link className="dx-menu-link" to={link}>
                                        <DxIcon type={icon} />
                                        <span className="dx-menu-link-text">{t(label)}</span>
                                    </Link>
                                ) : (
                                    <span className="dx-menu-link">
                                        <DxIcon type={icon} />
                                        <span className="dx-menu-link-text">{t(label)}</span>
                                    </span>
                                )}
                            </Menu.Item>
                        ),
                )}
            </Menu>
        </>
    );
};

export default LeftNavChannels;
